import axios from 'axios'

/*
 * Google Geocoding REST client. Avoids loading the JS SDK so the rest of
 * the app stays SDK-free. Same interface as Bing / OSM (search / handle /
 * reverseSearch / reverseHandle) so LocationService can swap providers.
 */
export default class GMaps {

    constructor(key, restrictedCountry, restrictedCity) {
        this.key = key
        this.restrictedCountry = restrictedCountry
        this.restrictedCity = restrictedCity
        this.errors = []
        this.domain = 'https://maps.googleapis.com/maps/api/geocode/json'
    }

    search(locationName) {
        const params = {
            address: locationName,
            key: this.key,
            language: 'fr'
        }
        if (this.restrictedCountry && this.restrictedCountry.length > 0) {
            params.components = `country:${this.restrictedCountry.slice(0, 2).toLowerCase()}`
        }
        return axios.get(this.domain, { params })
    }

    handle(response) {
        if (!response || response.status !== 'OK' || !Array.isArray(response.results)) {
            this.errors.push('error.search.noData')
            return []
        }

        const out = []
        const seen = new Set()
        response.results.forEach((r) => {
            const addr = r.formatted_address
            const loc = r.geometry && r.geometry.location
            if (!addr || !loc || seen.has(addr)) return
            out.push({
                address: addr,
                lat: loc.lat,
                lon: loc.lng
            })
            seen.add(addr)
        })
        return out
    }

    reverseSearch(coordinates) {
        return axios.get(this.domain, {
            params: {
                latlng: `${coordinates.lat},${coordinates.lon}`,
                key: this.key,
                language: 'fr'
            }
        })
    }

    reverseHandle(response) {
        if (!response || response.status !== 'OK' || !Array.isArray(response.results) || response.results.length === 0) {
            this.errors.push('error.search.noData')
            return ''
        }
        return response.results[0].formatted_address || ''
    }
}
